export function InvalidAddress({ homeHref = "/?view=overview" }: { homeHref?: string }) {
  return <main className="unlock-shell">
    <section className="unlock-card signin-card" aria-labelledby="invalid-address-title">
      <div className="unlock-brand"><span className="brand-mark" aria-hidden="true" /><div><strong>权宇宙</strong><small>家庭资产星图</small></div></div>
      <div className="unlock-copy">
        <span className="eyebrow">401 / Invalid address</span>
        <h1 id="invalid-address-title">地址无效或功能已下线</h1>
        <p>当前地址不属于可用的个人理财页面。你的登录状态不会因此退出。</p>
      </div>
      <a className="signin-button" href={homeHref}>返回家庭总览</a>
    </section>
  </main>;
}
